import { MantineThemeOverride } from '@mantine/core';

export type ImageTheme = NonNullable<MantineThemeOverride['components']>['Image'];

export const Image: ImageTheme = {
  // todo: define
};
